<template>
    <section :id="component.identifier ? component.identifier : ''"  class="mb-64" v-if="show">
        <component-header
            :title="title"
            :description="description"
        >
        </component-header>

        <div class="site__container flex justify-center">
            <div class="bg-white site__rounded--medium p-16">
                <div class="site__rounded--medium border site__border--text-light">
                    <table class="table-fixed">
                        <tr
                            v-for="(fact, index) in translatedFacts"
                            :key="'fact-' + fact.id"
                            :class="[ index < translatedFacts.length - 1 ? 'border-b-2 site__border--text-light' : '']"
                        >
                            <th class="w-1/2 px-24 py-16 border-r site__border--text-light font-normal text-right">{{ translated(fact.label) }}</th>
                            <td class="w-1/2 px-24 py-16 font-semibold site__color--brand text-left">{{ translated(fact.value) }}</td>
                        </tr>
            		</table>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ComponentHeader from './ComponentHeader.vue';
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { runningInBrowser } from '../../helpers';

export default {
    components: {
        'component-header': ComponentHeader,
    },
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {}
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        show () {
            return runningInBrowser() || this.hasContent;
        },
        hasContent () {
            return this.translatedFacts && !!this.translatedFacts.length;
        },
        translatedFacts: {
        	get () {
        		let facts = [];

        		for (let fact of this.component.facts) {
        			if (this.hasTrans(fact)) {
        				facts.push(fact);
        			}
        		}

        		return facts;
        	}
        },
        title: {
        	get () {
        		return this.translated(this.component.title);
        	}
        },
        description: {
        	get () {
                return this.translated(this.component.description);
        	}
        }
    },
    methods: {
    	hasTrans (fact) {
    		if (!this.translated(fact.label) &&
    			!this.translated(fact.value)) {
    			return false;
    		}

    		let label = this.translated(fact.label) ? this.translated(fact.label).trim() : null;
    		let value = this.translated(fact.value) ? this.translated(fact.value).trim() : null;

    		return label && label !== '' && value && value !== '';
    	}
    },
    mounted () {
        this.$emit('loaded');
    }
}
</script>

<style scoped>

</style>
